<template>
  <div
    class="flex flex-col flex-1 bg-light-grey p-5 rounded-xl overflow-hidden"
  >
    <h2 class="text-lg text-primary-900 mb-5">
      {{ $t("home.call_log") }}
    </h2>
    <div
      v-if="lastCalls.length === 0"
      class="flex flex-col flex-1 justify-center items-center h-full"
    >
      <p class="text-primary-900 text-sm">
        {{ $t("home.no_calls_history") }}
      </p>
    </div>
    <template v-else>
      <div class="flex flex-col flex-1 overflow-y-auto">
        <div
          v-for="(call, i) in lastCalls ? lastCalls : []"
          :key="i"
          class="flex justify-between items-center bg-white p-6 mb-5 rounded-xl w-full"
        >
          <div class="flex items-center gap-3">
            <v-icon
              :class="[
                'text-4xl',
                call.call_type == 1
                  ? 'text-primary-500'
                  : call.call_type == 2
                  ? 'text-orange-red'
                  : 'text-primary-900',
              ]"
              >{{
                call.call_type == 1
                  ? "mdi-phone-incoming"
                  : call.call_type == 2
                  ? "mdi-phone-outgoing"
                  : call.call_type == 3
                  ? "mdi-phone-refresh"
                  : "mdi-phone"
              }}</v-icon
            >
            <div>
              <p class="text-primary-900 text-sm">
                {{ call.number }}
              </p>
              <div class="flex items-center gap-1 mt-2 text-xs">
                <v-icon class="text-primary-500">mdi-clock-outline</v-icon>
                <p class="text-primary-500">
                  {{ getTime(call.time) }}
                </p>
                <div class="gap-5" />
                <v-icon class="text-primary-500"
                  >mdi-calendar-blank-outline</v-icon
                >
                <p class="text-primary-500">
                  {{ getDate(call.time) }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <Button
              class="bg-white text-xs hover:!bg-primary-900 hover:!text-white px-2 py-1 rounded-lg text-primary-900 border-solid border-primary-900 border"
              @click="
                showReasonDialog = true;
                selectedCall = call;
              "
            >
              <v-icon v-if="call?.reasons && call?.reasons.length > 0"
                >mdi-pencil</v-icon
              >
              <span v-else>
                {{ $t("calls.reasons.add_reason") }}
              </span>
            </Button>
            <v-tooltip
              v-if="call?.reasons && call?.reasons.length > 0 && call.reasons[0]"
              :text="call.reasons[0]"
              location="top"
            >
              <template v-slot:activator="{ props }">
                <span v-bind="props" class="text-primary-900 ml-2 cursor-pointer">
                  {{ getLastReasonPart(call.reasons[0]) }}
                </span>
              </template>
            </v-tooltip>
            <span v-else class="text-primary-900 ml-2"></span>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <Button
          class="bg-white hover:!bg-primary-900 hover:!text-white px-5 py-3 rounded-lg text-primary-900 border-solid border-primary-900 border"
          :label="$t('home.show_log')"
          @click="goToCallsLog"
        />
      </div>
    </template>
  </div>
  <Dialog
    class="w-1/2 h-3/4"
    v-model:visible="showReasonDialog"
    :header="
      selectedCall?.reasons && selectedCall?.reasons.length > 0
        ? $t('calls.reasons.edit_reason_btn')
        : $t('calls.reasons.add_reason')
    "
    :modal="true"
  >
    <NewCallReasons class="h-full" :call="selectedCall" />
  </Dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Button, Dialog } from "primevue";
import { getTime, getDate } from "@/utils";
import NewCallReasons from "@/pages/call/components/NewCallReasons.vue";

export default {
  components: { Button, Dialog, NewCallReasons },
  data() {
    return {
      lastCalls: [],
      callsInterval: null,
      showReasonDialog: false,
      selectedCall: null,
    };
  },
  methods: {
    ...mapActions(["GetAgentLastCalls", "SetMessageDialog"]),
    async getCalls() {
      try {
        var resp = await this.GetAgentLastCalls();
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        } else {
          this.lastCalls = resp.lastCalls;
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initCalls() {
      await this.getCalls();
      this.callsInterval = setInterval(() => {
        this.getCalls();
      }, 15000);
      this.$store.commit("setLastCallInterval", this.callsInterval);
    },
    getCallerNumberLocal(number) {
      return (
        this.$n(0, "mainNum", "ar-EG") +
        this.$n(parseInt(number, 10), "mainNum", "ar-EG")
      );
    },
    getCallDateLocal(date) {
      return this.$d(new Date(date), "long", "ar-EG");
    },
    getTime(date) {
      return getTime(date);
    },
    getDate(date) {
      return getDate(date);
    },
    getLastReasonPart(fullReason) {
      if (!fullReason) return '-';
      // Split by ' - ' separator and get the last part (leaf reason)
      const parts = fullReason.split(' - ');
      return parts[parts.length - 1] || fullReason;
    },
    goToCallsLog() {
      this.$router.push({
        name: "agent-calls-report",
      });
    },
  },
  computed: {
    ...mapGetters(["domain"]),
  },
  watch: {
    async domain(newValue) {
      if (newValue) {
        await this.initCalls();
      }
    },
  },
  async mounted() {
    if (this.domain) {
      await this.initCalls();
    }
  },
  beforeUnmount() {
    if (this.callsInterval) {
      clearInterval(this.callsInterval);
      this.callsInterval = null;
    }
  },
};
</script>

<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}
</style>
